import { EntityType } from "../entity-type.enum";

export class LegantoEntity {

    entityType : EntityType;
    id : string;

    constructor(entityType : EntityType, id : string) {
        this.entityType = entityType;
        this.id = id;
    }
}
